/** Llamadas HTTP del feature Sectores (zonas / rutas de lectura). */
import { apiRequest } from "../../lib/api";

export interface SectorRead {
  id: number;
  empresa_id: number;
  nombre: string;
  codigo: string | null;
  descripcion: string | null;
  latitud: number | null;
  longitud: number | null;
  dia_lectura: number;
  dia_facturacion: number;
  comuna_id: number | null;
  created_at: string;
  updated_at: string;
}

export interface SectorCreatePayload {
  nombre: string;
  codigo?: string | null;
  descripcion?: string | null;
  latitud?: number | null;
  longitud?: number | null;
  dia_lectura?: number;
  dia_facturacion?: number;
  comuna_id?: number | null;
}

export interface SectorUpdatePayload {
  nombre?: string;
  codigo?: string | null;
  descripcion?: string | null;
  latitud?: number | null;
  longitud?: number | null;
  dia_lectura?: number;
  dia_facturacion?: number;
  comuna_id?: number | null;
}

export function listarSectores(): Promise<SectorRead[]> {
  return apiRequest<SectorRead[]>("/api/v1/sectores");
}

export function crearSector(p: SectorCreatePayload): Promise<SectorRead> {
  return apiRequest<SectorRead>("/api/v1/sectores", { method: "POST", body: p });
}

export function actualizarSector(
  id: number,
  p: SectorUpdatePayload,
): Promise<SectorRead> {
  return apiRequest<SectorRead>(`/api/v1/sectores/${id}`, {
    method: "PATCH",
    body: p,
  });
}

export function eliminarSector(id: number): Promise<void> {
  return apiRequest<void>(`/api/v1/sectores/${id}`, { method: "DELETE" });
}
